import { useState } from "react";
import { MessageCircle, Instagram } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api, errMsg, LEVELS, SIDES } from "../lib/api";
import { Field, Logo } from "./common";

export const needsContact = (u) => u && u.role !== "admin" && !u.manual && !u.onboarded;

const mask = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

export const ContactOnboarding = () => {
  const { user, setUser } = useAuth();
  const [phone, setPhone] = useState(user?.phone ? mask(user.phone) : "");
  const [ig, setIg] = useState(user?.instagram || "");
  const [x, setX] = useState({ ct_name: user?.ct_name || "", level: user?.level || "", court_side: user?.court_side || "", play_time: user?.play_time || "", training: user?.training ?? null });
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    if (phone.replace(/\D/g, "").length < 10) return toast.error("Informe seu WhatsApp com DDD");
    if (!ig.trim() || !x.ct_name.trim() || !x.level || !x.court_side || !x.play_time.trim() || x.training === null) return toast.error("Preencha todos os campos");
    setBusy(true);
    try {
      const { data } = await api.put("/me/contact", { phone, instagram: ig, ...x });
      setUser(data);
      toast.success("Contato salvo!");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#0B0E14] px-5 py-8">
      <form onSubmit={save} data-testid="contact-onboarding" className="card-x w-full max-w-md space-y-5 p-8 rise">
        <div className="flex justify-center"><Logo where="login" max={90} /></div>
        <div className="text-center">
          <h1 className="h-display text-4xl">Complete seu cadastro</h1>
          <p className="mt-1 text-sm text-[#94A3B8]">Olá, {user?.name}! Preencha seus dados de atleta para continuar. Todos os campos são obrigatórios.</p>
        </div>
        <Field label="WhatsApp">
          <div className="relative">
            <MessageCircle className="absolute left-3 top-3.5 h-4 w-4 text-emerald-400" />
            <input required data-testid="onboarding-phone-input" inputMode="tel" className="inp pl-9" placeholder="(48) 99999-9999" value={phone} onChange={(e) => setPhone(mask(e.target.value))} />
          </div>
        </Field>
        <Field label="Instagram">
          <div className="relative">
            <Instagram className="absolute left-3 top-3.5 h-4 w-4 text-[#64748B]" />
            <input required data-testid="onboarding-instagram-input" className="inp pl-9" placeholder="@seuusuario" value={ig} onChange={(e) => setIg(e.target.value)} />
          </div>
        </Field>
        <Field label="Nome do CT"><input required data-testid="onboarding-ct-input" className="inp" placeholder="Onde você treina" value={x.ct_name} onChange={(e) => setX({ ...x, ct_name: e.target.value })} /></Field>
        <div className="grid grid-cols-2 gap-3">
          <Field label="Nível">
            <select required data-testid="onboarding-level-select" className="inp" value={x.level} onChange={(e) => setX({ ...x, level: e.target.value })}><option value="">Selecione</option>{LEVELS.map((l) => <option key={l}>{l}</option>)}</select>
          </Field>
          <Field label="Lado que joga">
            <select required data-testid="onboarding-side-select" className="inp" value={x.court_side} onChange={(e) => setX({ ...x, court_side: e.target.value })}><option value="">Selecione</option>{SIDES.map((l) => <option key={l}>{l}</option>)}</select>
          </Field>
        </div>
        <Field label="Quanto tempo joga"><input required data-testid="onboarding-playtime-input" className="inp" placeholder="Ex: 2 anos" value={x.play_time} onChange={(e) => setX({ ...x, play_time: e.target.value })} /></Field>
        <Field label="Está treinando?">
          <div className="grid grid-cols-2 gap-2">
            {[[true, "Sim"], [false, "Não"]].map(([v, l]) => (
              <button type="button" key={l} data-testid={`onboarding-training-${l === "Sim" ? "yes" : "no"}`} onClick={() => setX({ ...x, training: v })}
                className={`h-11 rounded-xl text-sm font-bold ${x.training === v ? "bg-[#E4F222] text-black" : "border border-[#232B3E] text-[#94A3B8]"}`}>{l}</button>
            ))}
          </div>
        </Field>
        <button disabled={busy} data-testid="onboarding-save-btn" className="btn-lime w-full rounded-full py-3">{busy ? "Salvando..." : "Continuar"}</button>
      </form>
    </div>
  );
};
